import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emp-separation-grid',
  templateUrl: './emp-separation-grid.component.html',
  styleUrls: ['./emp-separation-grid.component.css']
})
export class EmpSeparationGridComponent implements OnInit {
  title =" View Employee Separation"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Employee-Separation/emp-separation/emp-separation-grid/emp-separation-grid.component.ts